import Select from "react-select";
import {
  Form,
  FieldGroup,
  Label,
  Input,
  FullWidth,
  ScrollableTableContainer,
  Table,
  DivContainer,
  Header,
  HiddenInput,
  Select as DefaultSelect,
  CustomSelect,
} from "./Result.style";
import { FaSearch } from "react-icons/fa";
import { useCrearResultado } from "../../hooks/useCrearResult";
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from "react-icons/ai";
import SearchModal from "../../components/Modals/SearchModal";
import { BtnGeneral } from "../../styles/Buttons";

const CrearResultado = () => {
  const {
    formData,
    formVisible,
    excelData,
    validationResults,
    editRowIndex,
    excelLoaded,
    inputRefs,
    isModalOpen,
    consecutivos,
    handleOpenModal,
    handleCloseModal,
    handleSelectPaciente,
    handleChange,
    handleExcelUpload,
    handleCellChange,
    handleValidate,
    handleSaveExcelData,
    handleSaveData,
  } = useCrearResultado();

  const columnConfig = [
    { key: "consecutivo", label: "Actividad", type: "select" },
    { key: "APIM", label: "Código APIM", type: "text" },
    { key: "Tipo_APIM", label: "Finalidad", type: "text" },
    { key: "Fuente_APIM", label: "Fuente", type: "text" },
    { key: "Fecha_APIM", label: "Fecha del Resultado", type: "date" },
    { key: "Data_APIM1", label: "Resultado", type: "text" },
    { key: "Cantidad_APIM", label: "Cantidad", type: "number" },
    { key: "Cod_Diagnostico", label: "Código Diagnóstico", type: "text" },
    { key: "ID_Prestador", label: "ID Prestador", type: "text" },
    { key: "Tipo_ID_prestador", label: "Tipo ID Prestador", type: "text" },
  ];

  const columnConfigExcel = [
    { key: "Tipo_id", label: "Tipo", type: "text" },
    { key: "Identificacion", label: "Numero", type: "text" },
    { key: "consecutivo", label: "Actividad", type: "number" },
    { key: "APIM", label: "Código APIM", type: "text" },
    { key: "Tipo_APIM", label: "Finalidad", type: "text" },
    { key: "Fuente_APIM", label: "Fuente", type: "text" },
    { key: "Fecha_APIM", label: "Fecha Resultado", type: "date" },
    { key: "Data_APIM1", label: "Resultado", type: "text" },
    { key: "Cantidad_APIM", label: "Cantidad", type: "number" },
    { key: "Cod_Diagnostico", label: "Código Dx", type: "text" },
    { key: "ID_Prestador", label: "ID Prestador", type: "text" },
    { key: "Tipo_ID_prestador", label: "Tipo ID Prestador", type: "text" },
  ];

  return (
    <div className="div-container">
      <DivContainer excelLoaded={excelLoaded}>
        <Header>Cargar Resultados</Header>

        <Form visible={formVisible}>
          <FieldGroup className="wide">
            <Label>Paciente</Label>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "544px" }}>
              <Input
                style={{ flex: 0.92 }}
                value={
                  formData.Tipo_id && formData.Identificacion && formData.fullname
                    ? `${formData.Tipo_id} - ${formData.Identificacion} ${formData.fullname}`
                    : ""
                }
                readOnly
                placeholder="Seleccione un paciente"
              />
              <FaSearch
                style={{ cursor: "pointer", fontSize: "1.2rem", color: "#007bff" }}
                onClick={handleOpenModal}
                title="Buscar paciente"
              />
            </div>
          </FieldGroup>

          {columnConfig.map((col) => (
           <FieldGroup key={col.key}>
              <Label>{col.label}</Label>
              {col.type === "select" ? (
                col.key === "consecutivo" ? (
                  <CustomSelect>
                    <Select
                      options={consecutivos.map((item) => ({
                        value: item.Consecutivo,
                        label: item.Api        
                      }))}
                      value={
                        formData[col.key]
                          ? consecutivos
                              .map((item) => ({
                                value: item.Consecutivo,
                                label: item.Api,
                              }))
                              .find((opt) => opt.value === formData[col.key])
                          : null
                      }
                      onChange={(selectedOption) => {
                        handleChange({
                          target: {
                            name: col.key,
                            value: selectedOption ? selectedOption.value : "",
                          },
                        });
                      }}
                      placeholder="Buscar consecutivo..."
                      isClearable
                      isSearchable
                      classNamePrefix="react-select"
                    />
                  </CustomSelect>
                ) : (
                  <DefaultSelect
                    name={col.key}
                    value={formData[col.key] || ""}
                    onChange={handleChange}
                  >
                    <option value="">Seleccione...</option>
                    {col.options?.map((opt, idx) => (
                      <option key={idx} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </DefaultSelect>
                )
              ) : (
              <Input type={col.type} name={col.key}
                  value={formData[col.key] || ""}
                  onChange={handleChange}
              />
              )}
            </FieldGroup>
          ))}

          <FullWidth>
            <BtnGeneral mgt="20px" padding="10px 15px" dp="inline" onClick={handleSaveData}>
              Guardar Resultado
            </BtnGeneral>
            <HiddenInput id="file-upload" type="file" accept=".xlsx, .xls" onChange={handleExcelUpload} />
            <BtnGeneral bg="green" mgt="20px" padding="10px 15px" dp="inline" mgl="10px" onClick={() => document.getElementById("file-upload").click()}>
              Cargar Excel
            </BtnGeneral>
            
          </FullWidth>
        </Form>

        {/* Tabla */}
        {excelLoaded && (
          <>
            <ScrollableTableContainer excelLoaded={excelLoaded}>
              <Table>
                <thead>
                  <tr>
                    {columnConfigExcel.map(({ key, label }) => (
                      <th key={key}>{label}</th>
                    ))}
                    <th>Validación</th>
                  </tr>
                </thead>
                <tbody>
                  {excelData.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      {columnConfigExcel.map(({ key, type }) => (
                        <td key={key}>
                          {editRowIndex === rowIndex ? (
                            <input ref={(el) => (inputRefs.current[`row-${rowIndex}-${key}`] = el)} value={row[key] || ""} type={type} onChange={(e) => handleCellChange(e, rowIndex, key)} />
                          ) : (
                            row[key]
                          )}
                        </td>
                      ))}
                      <td style={{ textAlign: "center" }}>
                        { validationResults[rowIndex]?.valid === false ? ( <AiOutlineCloseCircle color="red" 
                          title={ validationResults[rowIndex]?.missing?.map(err => `El campo ${err.column} ${err.message}`).join(" | ") } size={20} /> ) : 
                            validationResults[rowIndex]?.valid === true ? (<AiOutlineCheckCircle color="green" size={20} />) : (<AiOutlineCheckCircle color="gray" size={20} />)} 
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </ScrollableTableContainer>

            <div style={{ padding: "15px" }}>
              <BtnGeneral mgt="20px" padding="5px 15px" dp="inline" onClick={handleValidate}> Validar </BtnGeneral>
              <BtnGeneral bg="excel" mgt="20px" padding="5px 15px" dp="inline" mgl="10px" 
                onClick={() => { document.getElementById("file-upload").value = ""; document.getElementById("file-upload").click(); }} > Cargar Excel </BtnGeneral>
              <BtnGeneral bg="green" mgt="20px" padding="5px 15px" dp="inline" mgl="10px" onClick={handleSaveExcelData} >Guardar</BtnGeneral>
              <BtnGeneral bg="gray" mgt="20px" padding="5px 15px" dp="inline" mgl="10px" onClick={() => { handleCloseModal(); window.location.reload(); }} > Volver </BtnGeneral>
            </div>
          </>
        )}

        <SearchModal
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          onSelect={handleSelectPaciente}
        />
      </DivContainer>
    {/* </Container> */}
    </div>
  );
};

export default CrearResultado;
